import { Card, CardContent, CardHeader, FormControl, FormControlLabel, FormHelperText, Grid2, IconButton, Stack, Switch } from "@mui/material"
import DashboardLayout from "../../../layoutcontainers/DashboardLayout"
import { useNavigate, useSearchParams } from "react-router-dom";
import { useSnackbar } from "../../../context/popup";
import { useLoading } from "../../../components/Loading";
import { Add, ArrowBack } from "@mui/icons-material";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialBox from "../../../components/MaterialBox";
import MaterialSelect from "../../../components/MasterSelect";
import { useInsurerRegistryFormHandling } from "./components/InsurerRegistryStateHandle";
import { useEffect, useState } from "react";
import MaterialInput from "../../../components/MaterialInput";
import MaterialButton from "../../../components/MaterialButton";
import { fetchData, fetchDataById, postData, putData } from "../../../services";
import DropDownConfig from "../../Utils/DropDownConfig";

const InsurerRegistryForm = () => {

    const [searchParams] = useSearchParams();
    const insurerRegistryId = searchParams.get("id");
    const pageType = searchParams.get("pageType");
    const pageMode = pageType === "view" ? "view" : pageType === "edit" ? "edit" : "add";
    const navigate = useNavigate();
    const { showSnackbar } = useSnackbar();
    const { setCircleLoading } = useLoading();

    const [generalInsurerOptions, setGeneralInsurerOptions] = useState([]);
    const [gLineOfBusinessOptions, setGLineOfBusinessOptions] = useState([]);
    const [generalProductOptions, setGeneralProductOptions] = useState([]);    
    const [generalSubProductOptions, setGeneralSubProductOptions] = useState([]);
    const [generalVehicleCategoryOptions, setGeneralVehicleCategoryOptions] = useState([]);

    const { formData, setFormData, handleTopLevelChange, handleProductChange, handleEnvironmentChange, handleAddProduct, handleAddEnvironment, checkAllFields } = useInsurerRegistryFormHandling(); 
    console.log("formData",formData);  

    useEffect(() => {
        if(pageMode === "view"){
            return
        }
        fetchAllDropdowns();
    }, [pageMode]);

    useEffect(() => {
        if (pageMode === "add" || !insurerRegistryId) {
            return;
        }

        //Fetch data by Pincode Id
        const fetchBankById = async (insurerRegistryId) => {
            try {
            const response = await fetchDataById(`/reference/api-engine/insurer_registry/${insurerRegistryId}`);

            const responseData = response?.data;
            
            if (response.success) {
                const mapped = {
                    name: responseData?.name || "",
                    iplBankId: responseData?.id || "",
                    active: responseData?.isActive,
                    // reset status fields
                    nameStatus: responseData?.name ? "success" : "unchecked",
                    iplBankIdStatus: responseData?.id ? "success" : "unchecked",

                };

                setFormData(mapped);   //view data
            }
            } catch (error) {
            console.error("Error fetching data by ID:", error);
            showSnackbar(error?.response?.data?.message,"error");
            }
        };

        fetchBankById(insurerRegistryId);
    }, [pageMode]);

    useEffect(() => {
        formData.products.forEach((product) => {
            const productId = product?.gProductId?.value;
            if (productId) {
                fetchSubProducts(productId);
            }
        });
    }, [formData.products]);



    //all dropdown api function
    const fetchAllDropdowns = async () => {
        setCircleLoading(true);

        try {
            const [
            insurerResponse,
            lobResponse,
            productResponse,
            subProductResponse,
            gVehicleCategoryResponse
            ] = await Promise.allSettled([
            fetchData(`/reference/general/insurer-master?dropdown=true&isActive=true`),
            fetchData(`/reference/general/key-value-store?dropdown=true&code=${DropDownConfig?.generalLineOfBusiness}`),
            fetchData(`/reference/general/key-value-store?dropdown=true&code=${DropDownConfig?.generalProduct}`),
            fetchData(`/reference/general/key-value-store?dropdown=true&code=${DropDownConfig?.generalSubProduct}`),
            fetchData(`/reference/general/key-value-store?dropdown=true&code=${DropDownConfig?.generalVehicleCategory}`),
            ]);

            const formattedInsurers = insurerResponse?.value?.data?.items?.map((item) => ({
                value: item?.id,
                label: item?.companyName,
            })) || [];
            
            const formattedLobs = lobResponse?.value?.data?.items?.map((item) => ({
                value: item?.id,
                label: item?.keyName,
            })) || [];

            const formattedProducts = productResponse?.value?.data?.items?.map((item) => ({
                value: item?.id,
                label: item?.keyName,
            })) || [];

            const formattedSubProducts = subProductResponse?.value?.data?.items?.map((item) => ({
                value: item?.id,
                label: item?.keyName,
            })) || [];

            const formattedVehicleCategories = gVehicleCategoryResponse?.value?.data?.items?.map((item) => ({
                value: item?.id,
                label: item?.keyName,
            })) || [];
            
            setGeneralInsurerOptions(formattedInsurers);
            setGLineOfBusinessOptions(formattedLobs);
            setGeneralProductOptions(formattedProducts);
            setGeneralSubProductOptions(formattedSubProducts);
            setGeneralVehicleCategoryOptions(formattedVehicleCategories);

        } catch (error) {
            console.error("Error fetching dropdown data:", error);
            showSnackbar(error?.response?.data?.message, "error");
        } finally {
            setCircleLoading(false);
        }
    };

    const fetchSubProducts = async(productId) => {
        try{

        }
        catch(error){
            console.error("Error Fetching Sub Product",error);
            showSnackbar(error?.response?.data?.message,"error");
        }
    }

    const handleSubmitInsurerRegistry = async () => {
        const payload = {
            gInsurerId: formData?.gInsurer?.value,
            gLobId: formData?.gLobId?.value,
            gProductId: formData?.gProductId?.value,
            gSubProductId: formData?.gSubProductId?.value,
            gVehicleCategoryId: formData?.gVehicleCategoryId?.value,
            environment: formData?.environment,
            integrationStatus: formData?.integrationStatus,
            onboardedAt: formData?.onboardedAt,
            notes: formData?.notes,
            isActive: formData?.isActive
        };
        //Update
        if(insurerRegistryId){
            try {
                const response = await putData(`/reference/api-engine/insurer-registry/${insurerRegistryId}`, payload);
                
                const responseMessage = response?.message;
                if(response?.success){
                //success message
                    showSnackbar(responseMessage, "success");
                    navigate('/api-integration-engine/insurer-registry');          
                }
                else{
                    //error message
                    showSnackbar(responseMessage, "error")
                }
            } catch (error) {
                console.error('Error updating data:', error);
                showSnackbar("Error Updating Body Type","error");
            }
        }
        else{      
        //Submit
            try {
                const response = await postData('/reference/api-engine/insurer-registry', payload);
                
                const responseMessage = response?.message;
                if(response?.success){
                    //success message
                    showSnackbar(responseMessage, "success");
                    navigate('/api-integration-engine/insurer-registry');          
                }
                else{
                    //error message
                    showSnackbar(responseMessage, "error");
                }
            } catch (error) {
                console.error('Error posting data:', error);
                //catch error message
                showSnackbar(error?.response?.data?.message,"error")
            }
        }
    };



  return (
    <DashboardLayout>
        <Card sx={{ minHeight: 500 }}>
            <CardHeader
            title={
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
              >
                <Stack direction="row" alignItems="center" spacing={1}>
                  <IconButton onClick={() => navigate("/api-integration-engine/insurer-registry")}>
                    <ArrowBack />
                  </IconButton>
                  <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h5" fontWeight="medium">
                      Insurer Registry Details
                    </MaterialTypography>
                    <MaterialTypography variant="caption" color="text">
                      Enter New Insurer Registry Details.
                    </MaterialTypography>
                  </Stack>
                </Stack>
              </Stack>
            }
            />
            <CardContent>
                <Grid2 container spacing={1}>
                    <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                        <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold">
                            General Insurer*
                        </MaterialTypography>
                        <MaterialSelect
                        name="gInsurer"
                        value={formData.gInsurer}
                        onChange={handleTopLevelChange}
                        options={generalInsurerOptions}
                        success={formData.gInsurerStatus === "success"}
                        error={formData.gInsurerStatus === "error"}
                        isDisabled={pageMode === "view"}
                        />
                    </Grid2>
                    <Grid2 size={{lg:2, md:2, sm: 3, xs: 6 }}>
                        <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold">
                            Actve
                        </MaterialTypography>
                        <FormControlLabel
                        control={
                            <Switch
                                checked={formData.isActive}
                                disabled={pageMode === "view"}
                                onChange={(e) =>
                                    handleTopLevelChange({
                                        target: {
                                            name: "isActive",
                                            value: e.target.checked,
                                        },
                                    })
                                }
                                color="primary"
                            />
                        }
                        label={
                            <MaterialTypography variant="caption" fontWeight="bold">
                                {formData?.isActive ? "Yes" : "No"}
                            </MaterialTypography>
                        }
                        sx={{ marginLeft: 0 }}
                        />
                    </Grid2>
                    <Grid2 size={{lg:12, md:12, sm: 12, xs: 12 }}>
                        {formData.products.map((product, index) => (
                        <MaterialBox border="1px solid #e0e0e0" borderRadius="8px" padding="16px" marginTop="8px">
                            <MaterialBox
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between"
                            >
                                <MaterialTypography variant="h6" fontWeight="medium">
                                {index + 1}. Product Details
                                </MaterialTypography>
                                <IconButton
                                    color="dark"
                                    onClick={handleAddProduct}
                                    disabled={pageMode === "view"}
                                    size="small"
                                    sx={{
                                        border: "1px solid",
                                        borderRadius: "4px",
                                        "&:hover": {
                                            backgroundColor: "#cccccc"
                                    }}}
                                >
                                    <Add /> 
                                    <MaterialTypography variant="caption" fontWeight="medium">Product</MaterialTypography>
                                </IconButton>
                            </MaterialBox>
                            <Grid2 container spacing={1}>
                                <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                                    <MaterialTypography
                                    component="label"
                                    variant="caption"
                                    fontWeight="bold">
                                        General Line Of Business*
                                    </MaterialTypography>
                                    <MaterialSelect
                                    name="gLobId"
                                    value={formData.products[index].gLobId}
                                    onChange={(value) => handleProductChange(index, "gLobId", value)}
                                    options={gLineOfBusinessOptions}
                                    success={formData.gLobIdStatus === "success"}
                                    error={formData.gLobIdStatus === "error"}
                                    isDisabled={pageMode === "view"}
                                    />
                                </Grid2>
                                <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                                    <MaterialTypography variant="caption" fontWeight="bold">
                                        General Product*
                                    </MaterialTypography>
                                    <MaterialSelect
                                        name="gProductId"
                                        value={formData.products[index].gProductId}
                                        options={generalProductOptions}
                                        onChange={(value) => handleProductChange(index, "gProductId", value)}
                                        success={formData.gProductIdStatus === "success"}
                                        error={formData.gProductIdStatus === "error"}
                                        isDisabled={pageMode === "view"}
                                    />
                                </Grid2>                  
                                <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                                    <MaterialTypography variant="caption" fontWeight="bold">
                                        General Sub Product*
                                    </MaterialTypography>
                                    <MaterialSelect
                                        name="gSubProductId"
                                        value={formData.products[index].gSubProductId}
                                        options={generalSubProductOptions}
                                        onChange={(e) => handleProductChange(index, "gSubProductId", e.target.value)}
                                        success={formData.gSubProductIdStatus === "success"}
                                        error={formData.gSubProductIdStatus === "error"}
                                        isDisabled={pageMode === "view"}
                                    />
                                </Grid2>
                                {formData.products[index]?.gProductId?.label === "Motor Product" && (
                                 <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                                    <MaterialTypography variant="caption" fontWeight="bold">
                                        General Vehicle Category*
                                    </MaterialTypography>
                                    <MaterialSelect
                                        name="gVehicleCategoryId"
                                        value={formData.products[index].gVehicleCategoryId}
                                        options={generalVehicleCategoryOptions}
                                        onChange={(e) => handleProductChange(index, "gVehicleCategoryId", e.target.value)}
                                        success={formData.gVehicleCategoryIdStatus === "success"}
                                        error={formData.gVehicleCategoryIdStatus === "error"}
                                        isDisabled={pageMode === "view"}
                                    />
                                </Grid2>
                                )}                                
                                <Grid2 size={{lg:2, md:2, sm: 3, xs: 6 }}>
                                        <MaterialTypography
                                        component="label"
                                        variant="caption"
                                        fontWeight="bold">
                                            Actve
                                        </MaterialTypography>
                                    <FormControlLabel
                                    control={
                                        <Switch
                                            checked={formData.products[index].isActive}
                                            disabled={pageMode === "view"}
                                            onChange={(e) =>
                                                handleProductChange(index, "isActive", e.target.checked)
                                            }
                                            color="primary"
                                        />
                                    }
                                    label={
                                        <MaterialTypography variant="caption" fontWeight="bold">
                                            {formData.products[index].isActive ? "Yes" : "No"}
                                        </MaterialTypography>
                                    }
                                    sx={{ marginLeft: 0 }}
                                    />
                                </Grid2>
                                <Grid2 size={{lg:12, md:12, sm: 12, xs: 12 }}>
                                    {product.environments.map((environmentData, envIndex) => (
                                    <MaterialBox border="1px solid #e0e0e0" borderRadius="8px" padding="16px" marginTop="8px">
                                        <MaterialBox
                                        display="flex"
                                        alignItems="center"
                                        justifyContent="space-between"
                                        >
                                        <MaterialTypography variant="h6" fontWeight="medium">
                                            {envIndex + 1}. Environment Details
                                        </MaterialTypography>

                                        <IconButton
                                            onClick={() => handleAddEnvironment(index)}
                                            disabled={pageMode === "view"}
                                            size="small"
                                            color="dark"
                                            sx={{
                                                border: "1px solid",
                                                borderRadius: "4px",
                                                "&:hover": {
                                                    backgroundColor: "#cccccc"
                                            }}}
                                        >
                                            <Add size="small"/>
                                            <MaterialTypography variant="caption" fontWeight="medium">Environment</MaterialTypography>
                                        </IconButton>
                                        </MaterialBox>
                                        <Grid2 container spacing={1}>
                                            <Grid2 size={{lg:6, md:6, sm: 6, xs: 12 }}>
                                                <MaterialTypography
                                                component="label"
                                                variant="caption"
                                                fontWeight="bold">
                                                    Environment*
                                                </MaterialTypography>
                                                <MaterialInput
                                                name="environmentId"
                                                placeholder="eg. Development"
                                                value={environmentData.environmentId}
                                                onChange={(e) => handleEnvironmentChange(index, envIndex, "environmentId", e.target.value)}
                                                success={environmentData.environmentIdStatus === "success"}
                                                error={environmentData.environmentIdStatus === "error"}
                                                disabled={pageMode === "view"}
                                                />
                                                {environmentData.environmentStatus === "error" && (
                                                    <FormControl error>
                                                        <FormHelperText>
                                                        Environment should be a minimum 1 character & maximum 100
                                                        characters long.
                                                        </FormHelperText>
                                                    </FormControl>
                                                )}
                                            </Grid2>
                                            <Grid2 size={{lg:6, md:6, sm: 6, xs: 12 }}>
                                                <MaterialTypography
                                                component="label"
                                                variant="caption"
                                                fontWeight="bold">
                                                    Integration Status*
                                                </MaterialTypography>
                                                <MaterialInput
                                                name="integrationStatusId"
                                                placeholder="eg. Success"
                                                value={environmentData.integrationStatusId}
                                                onChange={(e) => handleEnvironmentChange(index, envIndex, "integrationStatusId", e.target.value)}
                                                success={environmentData.integrationStatusIdStatus === "success"}
                                                error={environmentData.integrationStatusIdStatus === "error"}
                                                disabled={pageMode === "view"}
                                                />
                                                {environmentData.integrationStatusIdStatus === "error" && (
                                                    <FormControl error>
                                                        <FormHelperText>
                                                        Integration Status should be a minimum 1 character & maximum 100
                                                        characters long.
                                                        </FormHelperText>
                                                    </FormControl>
                                                )}
                                            </Grid2>
                                            <Grid2 size={{lg:6, md:6, sm: 6, xs: 12 }}>
                                                <MaterialTypography
                                                component="label"
                                                variant="caption"
                                                fontWeight="bold">
                                                    Onboarded At*
                                                </MaterialTypography>
                                                <MaterialInput
                                                name="onboardedAt"
                                                type="date"
                                                value={environmentData.onboardedAt}
                                                onChange={(e) =>  handleEnvironmentChange(index, envIndex, "onboardedAt", e.target.value)}
                                                success={environmentData.onboardedAtStatus === "success"}
                                                error={environmentData.onboardedAtStatus === "error"}
                                                disabled={pageMode === "view"}
                                                />
                                            </Grid2>
                                            <Grid2 size={{lg:6, md:6, sm: 6, xs: 12 }}>
                                                <MaterialTypography
                                                component="label"
                                                variant="caption"
                                                fontWeight="bold">
                                                    Notes
                                                </MaterialTypography>
                                                <MaterialInput
                                                name="notes"
                                                placeholder="eg. Registered with Accident policy"
                                                value={environmentData.notes}
                                                onChange={(e) => handleEnvironmentChange(index, envIndex, "notes", e.target.value)}
                                                success={environmentData.notesStatus === "success"}
                                                error={environmentData.notesStatus === "error"}
                                                disabled={pageMode === "view"}
                                                />
                                                {environmentData.notesStatus === "error" && (
                                                    <FormControl error>
                                                        <FormHelperText>
                                                        Notes should be a minimum 1 character & maximum 100
                                                        characters long.
                                                        </FormHelperText>
                                                    </FormControl>
                                                )}
                                            </Grid2>
                                            <Grid2 size={{lg:2, md:2, sm: 4, xs: 6 }}>
                                            <MaterialTypography
                                            component="label"
                                            variant="caption"
                                            fontWeight="bold">
                                                Actve
                                            </MaterialTypography>
                                            <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={environmentData.isActive}
                                                    disabled={pageMode === "view"}
                                                    onChange={(e) =>
                                                        handleEnvironmentChange(index, envIndex, "isActive", e.target.checked)
                                                    }
                                                    color="primary"
                                                />
                                            }
                                            label={
                                                <MaterialTypography variant="caption" fontWeight="bold">
                                                    {environmentData?.isActive ? "Yes" : "No"}
                                                </MaterialTypography>
                                            }
                                            sx={{ marginLeft: 0 }}
                                            />
                                            </Grid2>
                                        </Grid2>
                                    </MaterialBox>
                                    ))}
                                </Grid2>
                            </Grid2>
                        </MaterialBox>
                        ))}
                    </Grid2>
                </Grid2>
            </CardContent>
                <MaterialBox
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                >
                    {pageMode !== "view" && (
                    <>
                        <MaterialButton
                        sx={{ m: 2 }}
                        variant="outlined"
                        color="dark"
                        onClick={() => navigate("/api-integration-engine/insurer-registry")}
                        >
                        Cancel
                        </MaterialButton>
                        <MaterialButton
                        sx={{ m: 2 }}
                        variant="gradient"
                        color="dark"
                        disabled={!checkAllFields()}
                        onClick={handleSubmitInsurerRegistry}
                        >
                        {pageMode === "edit" ? "Update" : "Submit"}
                        </MaterialButton>
                    </>
                    )}
                </MaterialBox>
        </Card> 
    </DashboardLayout>
  )
}

export default InsurerRegistryForm